module.exports = __webpack_public_path__ + "static/media/AppStore.9e4775b0.jpg";